<template>
  <div class="recharge-record-page common-bg" style="width: 100%; min-height: 100vh;">
    <van-nav-bar fixed title="充值记录" left-arrow @click-left="$router.back()" />
    <div style="height: 46px;"></div>

    <div class="rr-wrap">
      <div class="rr-header">
        <div class="rr-filters">
          <div class="rr-filter" @click="toggleDateDropdown">
            <span>{{ dateFilterText }}</span>
            <van-icon :name="showDateDropdown ? 'arrow-up' : 'arrow-down'" size="12" />
          </div>
          <div class="rr-filter" @click="toggleStatusDropdown">
            <span>{{ statusFilterText }}</span>
            <van-icon :name="showStatusDropdown ? 'arrow-up' : 'arrow-down'" size="12" />
          </div>
        </div>
        <div class="rr-total">
          <div class="rr-total-label">累计充值</div>
          <div class="rr-total-amount">
            ¥{{ totalAmount }}
            <img class="rr-total-refresh" src="/static/image/iconRefresh.png" @click="refreshData" alt="刷新" />
          </div>
        </div>

        <!-- 日期下拉（3行3列：前2行日期选项；第3行占位/取消/确认） -->
        <div class="rr-date-dropdown" v-if="showDateDropdown">
          <div class="rr-date-options">
            <div
              v-for="opt in dateOptions"
              :key="opt.value"
              class="rr-date-option"
              :class="{ active: dateFilter === opt.value }"
              @click="selectDate(opt.value)"
            >{{ opt.label }}</div>
            <!-- 第 3 行 3 列：第 1 列空占位，第 2 列取消，第 3 列确认（与上面 3 列严格对齐） -->
            <div class="rr-date-option rr-date-option-placeholder"></div>
            <div class="rr-date-btn rr-date-btn-cancel" @click="showDateDropdown = false">取消</div>
            <div class="rr-date-btn rr-date-btn-confirm" @click="showDateDropdown = false">确认</div>
          </div>
        </div>

        <!-- 状态下拉 -->
        <div class="rr-status-dropdown" v-if="showStatusDropdown">
          <div
            v-for="opt in statusOptions"
            :key="opt.value"
            class="rr-status-option"
            :class="{ active: statusFilter === opt.value }"
            @click="selectStatus(opt.value)"
          >{{ opt.label }}</div>
        </div>
      </div>

      <!-- 记录列表 -->
      <div class="rr-list" v-if="recordList.length > 0">
        <div class="rr-item" v-for="item in recordList" :key="item.id">
          <div class="rr-item-top">
            <span class="rr-type">{{ item.pay_way_text || item.type || '充值' }}</span>
            <span :class="['rr-state', `state-${item.state_code}`]">{{ item.state_text }}</span>
          </div>

          <div class="rr-row">
            <span class="rr-label">金额</span>
            <span class="rr-amount">￥{{ formatNumber(item.amount) }}</span>
          </div>
          <div class="rr-row" v-if="Number(item.real_money) !== Number(item.amount) && Number(item.real_money) > 0">
            <span class="rr-label">实付</span>
            <span class="rr-real">￥{{ formatNumber(item.real_money) }}</span>
          </div>
          <div class="rr-row">
            <span class="rr-label">单号</span>
            <span class="rr-order" @click="doCopy(item.out_trade_no, '单号已复制')">{{ item.out_trade_no || ('ID:' + item.id) }}</span>
          </div>
          <div class="rr-row" v-if="item.reject_reason">
            <span class="rr-label">驳回原因</span>
            <span class="rr-reject">{{ item.reject_reason }}</span>
          </div>
          <div class="rr-row rr-row-foot">
            <span class="rr-time">{{ formatTime(item.created_at) }}</span>
            <span v-if="item.pay_qrcode" class="rr-proof" @click="previewProof(item)">查看凭证</span>
          </div>
        </div>

        <div class="rr-loadmore" v-if="hasMore && !loadingRecord" @click="loadMore">加载更多</div>
        <div class="rr-loadmore rr-nomore" v-if="!hasMore && !loadingRecord">— 没有更多记录了 —</div>
      </div>

      <!-- 空状态 -->
      <div class="rr-empty" v-else-if="!loadingRecord">
        <img src="/static/image/img_none_sj.avif" class="rr-empty-icon" />
        <div class="rr-empty-text">暂无充值记录</div>
      </div>

      <div class="rr-loading" v-else-if="loadingRecord">加载中…</div>
    </div>
  </div>
</template>

<script>
import { ImagePreview } from 'vant';
export default {
  name: 'RechargeRecord',
  data() {
    return {
      showDateDropdown: false,
      showStatusDropdown: false,
      dateOptions: [
        { value: 'today',     label: '今日' },
        { value: 'yesterday', label: '昨日' },
        { value: 'week',      label: '本周' },
        { value: 'lastweek',  label: '上周' },
        { value: 'month',     label: '本月' },
        { value: 'all',       label: '全部' },
      ],
      statusOptions: [
        { value: '',  label: '全部状态' },
        { value: '1', label: '待审核' },
        { value: '2', label: '已通过' },
        { value: '3', label: '已驳回' },
      ],
      dateFilter: 'all',
      statusFilter: '',
      recordList: [],
      recordPage: 1,
      recordPageSize: 10,
      recordTotal: 0,
      recordLastPage: 1,
      loadingRecord: false,
      totalAmount: '0.00',
    };
  },
  computed: {
    dateFilterText() {
      const f = this.dateOptions.find(o => o.value === this.dateFilter);
      return f ? f.label : '全部';
    },
    statusFilterText() {
      if (this.statusFilter === '') return '全部状态';
      const f = this.statusOptions.find(o => o.value === this.statusFilter);
      return f ? f.label : '全部状态';
    },
    hasMore() {
      if (this.recordLastPage > 1) return this.recordPage < this.recordLastPage;
      if (!this.recordTotal) return this.recordList.length >= this.recordPageSize;
      return this.recordList.length < this.recordTotal;
    },
  },
  created() {
    this.fetchRecord(true);
  },
  mounted() {
    window.addEventListener('scroll', this.onScroll);
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.onScroll);
  },
  methods: {
    toggleDateDropdown() {
      this.showDateDropdown = !this.showDateDropdown;
      if (this.showDateDropdown) this.showStatusDropdown = false;
    },
    toggleStatusDropdown() {
      this.showStatusDropdown = !this.showStatusDropdown;
      if (this.showStatusDropdown) this.showDateDropdown = false;
    },
    selectDate(v) {
      if (this.dateFilter === v) { this.showDateDropdown = false; return; }
      this.dateFilter = v;
      this.showDateDropdown = false;
      this.recordPage = 1;
      this.fetchRecord(true);
    },
    selectStatus(v) {
      if (this.statusFilter === v) { this.showStatusDropdown = false; return; }
      this.statusFilter = v;
      this.showStatusDropdown = false;
      this.recordPage = 1;
      this.fetchRecord(true);
    },
    refreshData() {
      this.recordPage = 1;
      this.fetchRecord(true);
    },
    loadMore() {
      if (this.loadingRecord || !this.hasMore) return;
      this.recordPage += 1;
      this.fetchRecord(false);
    },
    onScroll() {
      if (this.loadingRecord || !this.hasMore) return;
      const scrollTop = window.scrollY || document.documentElement.scrollTop;
      const h = window.innerHeight;
      const pageH = document.documentElement.scrollHeight;
      if (scrollTop + h >= pageH - 100) this.loadMore();
    },
    fetchRecord(reset) {
      const that = this;
      if (that.loadingRecord) return;
      if (reset) {
        that.showLoading && that.showLoading();
      }
      that.loadingRecord = true;
      const params = {
        date_type: that.dateFilter,
        state: that.statusFilter,
        page: that.recordPage,
        page_size: that.recordPageSize,
      };
      that.$apiFun.post('/api/getrechargerecord', params)
        .then(res => {
          that.loadingRecord = false;
          if (reset) that.hideLoading && that.hideLoading();
          if (res.code == 200) {
            const body = res.data || {};
            let list = Array.isArray(body) ? body : (body.list || []);
            if (!Array.isArray(list) && list && list.data && Array.isArray(list.data)) list = list.data;
            that.recordList = reset ? list : that.recordList.concat(list);
            if (body.total !== undefined) that.recordTotal = parseInt(body.total, 10) || 0;
            else if (list.length < that.recordPageSize) that.recordTotal = that.recordList.length;
            if (body.last_page !== undefined) that.recordLastPage = parseInt(body.last_page, 10) || 1;
            else if (body.current_page !== undefined && body.last_page === undefined) that.recordLastPage = body.current_page + (list.length < that.recordPageSize ? 0 : 1);
            // 累计金额：首次加载时把当前条件下 total_amount 一起返回（若后端未返回，用前端累加兜底）
            if (body.total_amount !== undefined && reset) {
              that.totalAmount = that.formatNumber(body.total_amount);
            } else if (reset) {
              const sum = that.recordList.reduce((acc, it) => acc + (Number(it.amount) || 0), 0);
              that.totalAmount = that.formatNumber(sum);
            }
          } else {
            that.showTost(0, res.message || '获取充值记录失败');
          }
        })
        .catch(() => {
          that.loadingRecord = false;
          if (reset) that.hideLoading && that.hideLoading();
          that.showTost(0, '网络错误，请重试');
        });
    },
    formatNumber(v) {
      const n = Number(v || 0);
      return isNaN(n) ? '0.00' : n.toFixed(2);
    },
    formatTime(v) {
      if (!v) return '';
      return String(v).replace('T', ' ').substr(0, 16);
    },
    previewProof(item) {
      if (!item || !item.pay_qrcode) return;
      ImagePreview({
        images: [this.$imgUrl(item.pay_qrcode)],
        startPosition: 0,
      });
    },
    doCopy(msg, toastMsg) {
      if (!msg) return;
      const cInput = document.createElement('input');
      cInput.style.opacity = '0';
      cInput.value = msg;
      document.body.appendChild(cInput);
      cInput.select();
      document.execCommand('copy');
      document.body.removeChild(cInput);
      this.showTost(1, toastMsg || '复制成功！');
    },
    showLoading() { if (this.$root && this.$root.showLoading) this.$root.showLoading(); else if (this.$parent && this.$parent.showLoading) this.$parent.showLoading(); },
    hideLoading() { if (this.$root && this.$root.hideLoading) this.$root.hideLoading(); else if (this.$parent && this.$parent.hideLoading) this.$parent.hideLoading(); },
    showTost(type, title) { if (this.$root && this.$root.showTost) this.$root.showTost(type, title); else if (this.$parent && this.$parent.showTost) this.$parent.showTost(type, title); },
  },
};
</script>

<style lang="scss" scoped>
.recharge-record-page {
  color: #fff;
}

.rr-wrap {
  padding: 0.2rem;
}

/* 顶部筛选 + 累计充值 */
.rr-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 0.2rem;
  position: relative;
  z-index: 10;
}

.rr-filters {
  display: flex;
  gap: 0.15rem;
}

.rr-filter {
  display: flex;
  align-items: center;
  gap: 0.05rem;
  padding: 0.1rem 0.2rem;
  border: 1px solid #555;
  border-radius: 0.3rem;
  font-size: 0.3rem;
  color: #ccc;
  cursor: pointer;
}

.rr-total {
  text-align: right;
}

.rr-total-label {
  font-size: 0.3rem;
  color: #999;
  margin-bottom: 0.05rem;
}

.rr-total-amount {
  font-size: 0.3rem;
  color: #fff;
  font-weight: bold;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 0.05rem;

  .rr-total-refresh {
    width: 0.25rem;
    height: 0.25rem;
    cursor: pointer;
  }
}

/* 日期下拉 */
.rr-date-dropdown {
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  background: #222;
  border-radius: 0.15rem;
  padding: 0.3rem;
  z-index: 100;
  margin-top: 0.1rem;
}

.rr-date-options {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-column-gap: 0.2rem;
  grid-row-gap: 0.15rem;
  margin-bottom: 0.1rem;
}

.rr-date-option {
  width: 100%;
  box-sizing: border-box;
  text-align: center;
  padding: 0.25rem 0;
  border: 1px solid #555;
  border-radius: 0.1rem;
  font-size: 0.32rem;
  color: #fff;
  cursor: pointer;

  &.active { border-color: #DFB372; color: #DFB372; }
}

.rr-date-option-placeholder {
  border: none;
  background: transparent;
  cursor: default;
  pointer-events: none;
}

.rr-date-btn {
  width: 100%;
  box-sizing: border-box;
  padding: 0.25rem 0;
  border-radius: 0.1rem;
  font-size: 0.32rem;
  cursor: pointer;
  text-align: center;
}

.rr-date-btn-cancel {
  border: 1px solid #DFB372;
  color: #DFB372;
}

.rr-date-btn-confirm {
  background: #DFB372;
  color: #1a1a1a;
}

/* 状态下拉 */
.rr-status-dropdown {
  position: absolute;
  top: 100%;
  left: 1.6rem;
  width: 3rem;
  background: #222;
  border-radius: 0.15rem;
  padding: 0.1rem 0;
  z-index: 100;
  max-height: 3.5rem;
  overflow-y: auto;
  margin-top: 0.1rem;
}

.rr-status-option {
  padding: 0.2rem 0.3rem;
  font-size: 0.32rem;
  color: #999;
  cursor: pointer;

  &.active { color: #DFB372; }
}

/* 记录卡片列表 */
.rr-list {
  padding: 0;
  margin-bottom: 2rem;
}

.rr-item {
  background: #222;
  border-radius: 0.12rem;
  padding: 0.2rem 0.3rem;
  margin-bottom: 0.2rem;
}

.rr-item-top {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 0.1rem;
  padding-bottom: 0.1rem;
  border-bottom: 1px dashed #333;

  .rr-type {
    font-size: 0.3rem;
    color: #d1ae52;
    background: rgba(209,174,82,0.15);
    padding: 0.03rem 0.12rem;
    border-radius: 0.04rem;
  }

  .rr-state {
    font-size: 0.24rem;
    padding: 0.04rem 0.15rem;
    border-radius: 0.3rem;
  }
  .rr-state.state-1 { background: rgba(255,184,0,0.15); color: #FFB800; }
  .rr-state.state-2 { background: rgba(0,196,120,0.15); color: #00C478; }
  .rr-state.state-3 { background: rgba(255,82,82,0.15);  color: #FF5252; }
}

.rr-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0.06rem 0;
  font-size: 0.26rem;

  .rr-label { color: #999; flex-shrink: 0; margin-right: 0.15rem; }
  .rr-amount { color: #fff; font-weight: 700; font-size: 0.32rem; }
  .rr-real   { color: #ddd; }
  .rr-order  {
    color: #d1ae52;
    word-break: break-all;
    text-align: right;
    max-width: 70%;
    cursor: pointer;
  }
  .rr-reject {
    color: #FF5252;
    text-align: right;
    max-width: 72%;
    line-height: 0.4rem;
  }
}

.rr-row-foot {
  padding-top: 0.1rem;
  margin-top: 0.08rem;
  border-top: 1px dashed #333;

  .rr-time  { color: #666; letter-spacing: 0.03rem; font-size: 0.24rem; }
  .rr-proof { color: #DFB372; cursor: pointer; font-size: 0.26rem; }
}

.rr-loadmore {
  text-align: center;
  padding: 0.2rem 0;
  margin-bottom: 0.2rem;
  font-size: 0.28rem;
  color: #d1ae52;
  cursor: pointer;
}

.rr-loadmore.rr-nomore {
  cursor: default;
  color: #888;
}

/* 空状态 */
.rr-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  padding: 3rem 0;
  color: #666;

  .rr-empty-icon {
    width: 3rem;
    height: 3rem;
    margin-bottom: 0.2rem;
  }
  .rr-empty-text {
    font-size: 0.35rem;
    color: #666;
  }
}

.rr-loading {
  text-align: center;
  padding: 0.6rem 0;
  color: #888;
  font-size: 0.28rem;
}
</style>



// WEBPACK FOOTER //
// src/components/view/recharge/RechargeRecord.vue